var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_print_2092089") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module-/-Recommendations",
    transform: "translate(-404.000000, -5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -1.000000)",
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(404.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_print_2092089"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.764501,5.06052503 L16.0375,5.06052503 L16.0375,0.978692031 C16.0374976,0.60214008 15.7322457,0.296875 15.3556937,0.296875 L4.64432997,0.296875 C4.46349707,0.296875 4.29007028,0.36870894 4.16220211,0.496577111 C4.03433394,0.624445282 3.96249886,0.797872067 3.9625,0.978704969 L3.9625,5.06052503 L2.2375,5.06052503 C1.16702201,5.06365608 0.300006049,5.93067204 0.296875,7.00115003 L0.296875,14.2830737 C0.296875,14.4643111 0.368870605,14.6381256 0.497025012,14.7662796 C0.625179418,14.8944336 0.79899418,14.9664292 0.980231594,14.9664281 L3.9625,14.9664281 L3.9625,19.021295 C3.96249886,19.2021279 4.03433394,19.3755547 4.16220211,19.5034229 C4.29007028,19.6312911 4.46349707,19.703125 4.64432997,19.703125 L15.35567,19.703125 C15.5365029,19.703125 15.7099297,19.6312911 15.8377979,19.5034229 C15.9656661,19.3755547 16.0375011,19.2021279 16.0375,19.021295 L16.0375,14.9664281 L19.0178688,14.9664281 C19.3963228,14.9664281 19.703125,14.6596324 19.703125,14.2811783 L19.703125,6.99914688 C19.703125,6.48499185 19.4988784,5.99189513 19.1353157,5.62833283 C18.771753,5.26477052 18.278656,5.06052389 17.764501,5.06052503 Z M15.1748943,18.8406379 L4.82489434,18.8406379 L4.82489434,11.7368982 L15.1748943,11.7368982 L15.1748943,18.8406379 Z M15.1748943,5.06052503 L4.82489434,5.06052503 L4.82489434,1.15938794 L15.1748943,1.15938794 L15.1748943,5.06052503 Z M16.756232,8.79802 C16.3195835,8.79802 15.9656279,8.44402768 15.9656279,8.00737919 C15.9656279,7.57073069 16.319618,7.21677288 16.7562665,7.21677288 C17.192915,7.21677288 17.546875,7.57076088 17.546875,8.00740938 C17.546875,8.21709813 17.4635751,8.41819827 17.3152997,8.56646758 C17.1670243,8.71473688 16.9659208,8.79802 16.756232,8.79802 L16.756232,8.79802 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.45657184,
    y: 12.8335648,
    width: 7.08677653,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.45657184,
    y: 14.8358887,
    width: 7.08677653,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.45657184,
    y: 16.8383162,
    width: 7.08677653,
    height: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter);
export default __webpack_public_path__ + "static/media/Icon-Printer.87e35a19439f2a08cc2d8094646a4129.svg";
export { ForwardRef as ReactComponent };